import {
    RiDatabase2Line,
    RiCodeSSlashFill,
    RiLayoutLine,
    RiSettings4Line,
} from "react-icons/ri";

const AboutData = {
    Descriptions: [
        {
            key: "1",
            text: "I'm Natanael Geraldo — a Full-Stack Engineer with 5+ years of professional experience. I lead the development of scalable internal platforms used across departments at Cora Group (AU), focusing on backend architecture, performance optimization, and long-term system reliability.",
        },
        {
            key: "2",
            text: "My core stack is .NET (ASP.NET Core, C#, SQL Server) on the backend and React.js on the frontend. I build systems that stay up, scale under real load, and ship on time — from initial architecture through to production deployment.",
        },
    ],
    Doings: [
        {
            key: "1",
            Icon: <RiDatabase2Line size={26} />,
            Title: "Enterprise Backend",
            Description: "ASP.NET Core · C# · SQL Server · .NET Framework",
        },
        {
            key: "2",
            Icon: <RiCodeSSlashFill size={26} />,
            Title: "Frontend Engineering",
            Description: "React.js · TypeScript · JavaScript · Tailwind CSS",
        },
        {
            key: "3",
            Icon: <RiLayoutLine size={26} />,
            Title: "Internal Platforms",
            Description: "Web Portals · Admin Systems · API Integrations",
        },
        {
            key: "4",
            Icon: <RiSettings4Line size={26} />,
            Title: "System Architecture",
            Description: "Performance Tuning · DB Optimization · API Design",
        },
    ],
};

export default AboutData;
